import React from "react";
import { observer, inject } from "mobx-react";
import { Modal, Button, Breadcrumb } from "react-bootstrap";
import { STORE_CUSTOMERS, STORE_CREATE_EDIT_CUSTOMER_ORDER, SOURCES_ABTEKA, SOURCES_AB61 } from "../../../../../constants";
import { CustomersStore, CreateOrderPosition, CreateEditCustomerOrderStore } from "../../../../../stores";
import { ConfirmationTable } from "./ConfirmationTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ConfirmationStep2As } from "./ConfirmationStep2/ConfirmationStep2As";
import { ConfirmationStep2Abteka } from "./ConfirmationStep2/ConfirmationStep2Abteka";
import { ConfirmationStep2Ab } from "./ConfirmationStep2/ConfirmationStep2Ab";

interface IProps {
    isOpened: boolean;
    source: string;
    positions: CreateOrderPosition[];
    confirmOrder: boolean;
    sendPaymentLink: boolean;
    confirmCallback: () => void;
    cancelCallback: () => void;
    deliveryType: "delivery" | "pickup";
    paymentType: "Cache" | "Cacheless" | "ByReceipt";
    isUrgent: boolean;
    setAddressTypeCallback: (deliveryType: "delivery" | "pickup", isUrgent: boolean) => void;
    setPaymentTypeCallback: (paymentType: "Cache" | "Cacheless" | "ByReceipt") => void;
    changeAbtekaCheckboxesHandler: (confirmOrder: boolean, sendPaymentLink: boolean) => void;
}

interface IState {
    step: "table" | "delivery";
}

@inject(STORE_CREATE_EDIT_CUSTOMER_ORDER, STORE_CUSTOMERS)
@observer
export class ConfirmationModal extends React.Component<IProps, IState> {
    constructor(props: any) {
        super(props);
        this.state = {
            step: "table"
        }

    }
    createEditStore = (this.props as any)[STORE_CREATE_EDIT_CUSTOMER_ORDER] as CreateEditCustomerOrderStore;
    customersStore = (this.props as any)[STORE_CUSTOMERS] as CustomersStore;
    notificationStore = this.customersStore._rootStore.notificationStore;

    private toTableHandler = () => {
        this.setState({
            step: "table"
        })
    }
    private toAddressStepHandler = () => {
        this.setState({
            step: "delivery"
        })
    }

    componentDidUpdate(prevProps: IProps) {
        if (this.props.isOpened !== prevProps.isOpened) {
            this.setState({
                step: "table"
            })
        }
    }

    private changeAbtekaCheckboxesHandler = (fieldName: string, value: string, checked: boolean) => {
        if (fieldName == "confirmOrder") {
            this.props.changeAbtekaCheckboxesHandler(checked, this.props.sendPaymentLink);
        }
        else
            this.props.changeAbtekaCheckboxesHandler(this.props.confirmOrder, checked);
    }

    render() {
        return <Modal show={this.props.isOpened} onHide={this.props.cancelCallback} className="modal-xxl" >
            <Modal.Header closeButton>
                <Modal.Title>
                    Подтверждение заказа - <h5 style={{ display: "inline" }}>{this.state.step == "table" ? "Список товара" : "Параметры доставки"}</h5>
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Breadcrumb>
                    <Breadcrumb.Item active={this.state.step == "table"} onClick={this.toTableHandler} >
                        Список товара
                    </Breadcrumb.Item>
                    <Breadcrumb.Item active={this.state.step == "delivery"} onClick={this.toAddressStepHandler}>Доставка</Breadcrumb.Item>
                </Breadcrumb>
                {this.state.step == "table" ? <ConfirmationTable
                    positions={this.props.positions} /> : this.props.source === SOURCES_ABTEKA ?
                    <ConfirmationStep2Abteka
                        confirmOrder={this.props.confirmOrder}
                        sendPaymentLink={this.props.sendPaymentLink}
                        changeCheckboxesCallback={this.changeAbtekaCheckboxesHandler} /> :
                    this.props.source == SOURCES_AB61 ?
                        <ConfirmationStep2Ab
                            isUrgent={this.props.isUrgent}
                            deliveryType={this.props.deliveryType}
                            paymentType={this.props.paymentType}
                            sendPaymentLink={this.props.sendPaymentLink}
                            setPaymentTypeCallback={this.props.setPaymentTypeCallback}
                            setAddressTypeCallback={this.props.setAddressTypeCallback}
                            changeCheckboxesCallback={this.changeAbtekaCheckboxesHandler} /> :
                        <ConfirmationStep2As
                            isUrgent={this.props.isUrgent}
                            deliveryType={this.props.deliveryType}
                            setAddressTypeCallback={this.props.setAddressTypeCallback} />}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={this.props.cancelCallback}>
                    Отмена
                </Button>
                {this.state.step == "delivery"
                    ?
                    [
                        <Button variant="secondary" onClick={this.toTableHandler} key={1}>Назад</Button>,
                        <Button variant="primary" onClick={this.props.confirmCallback} key={2}>
                            <FontAwesomeIcon icon="save" />
                            Отправить в работу
                        </Button>
                    ] :
                    <Button variant="outline-primary" onClick={this.toAddressStepHandler} key={1}>
                        Дальше
                    </Button>}

            </Modal.Footer>
        </Modal>
    }
}